import { CLEAR_MARKETING_CAMPAIGNS,
         SET_MARKETING_CAMPAIGNS,
         SET_ACTIVE_MARKETING_CAMPAIGN,
         SET_ERRORS,
         CLEAR_ERRORS,
         MANAGE_LOADING_MARKETING_CAMPAIGNS,
         MANAGE_REQUESTING_RESOURCE } from './mutation-types.js';
import { realEstateDataSvc } from '../../../shared/services/data-service-real-estate.js';

async function retrieveMarketingCampaigns() {
    const searchInfo = { pageSize: 200 };
    const marketingCampaigns = [];
    var pageInfo = await realEstateDataSvc.getAllMarketingCampaigns(searchInfo);
    marketingCampaigns.push.apply(marketingCampaigns, pageInfo.marketingCampaigns);
    while (pageInfo.nextPageLink) {
        searchInfo['pageLink'] = pageInfo.nextPageLink;
        pageInfo = await realEstateDataSvc.getAllMarketingCampaigns(searchInfo);
        marketingCampaigns.push.apply(marketingCampaigns, pageInfo.marketingCampaigns);
    }
    return marketingCampaigns;
}

async function retrieveMarketingCampaignByCampaignKey(campaignKey) {
    const searchInfo = { pageSize: 200 };
    var pageInfo = await realEstateDataSvc.getMarketingCampaignByCampaignKey(searchInfo, campaignKey);
    if (pageInfo.marketingCampaigns.length === 1) {
        return pageInfo.marketingCampaigns[0];
    }
    console.error(`failed to get marketing by campaign key: [${campaignKey}] - should be just one entry found - but found:`);
    console.error(pageInfo.marketingCampaigns);
    return null;
}

export default {
    async loadAllMarketingCampaigns(context) {
        context.commit(MANAGE_LOADING_MARKETING_CAMPAIGNS, true);
        context.commit(CLEAR_MARKETING_CAMPAIGNS);
        const marketingCampaigns = await retrieveMarketingCampaigns();
        context.commit(SET_MARKETING_CAMPAIGNS, marketingCampaigns);
        context.commit(MANAGE_LOADING_MARKETING_CAMPAIGNS, false);
    },
    async setActiveMarketingCampaignByCampaignKey(context, payload) {
        console.log(`calling setActiveMarketingCampaignByCampaignKey with key: [${payload}]`);
        context.commit(MANAGE_LOADING_MARKETING_CAMPAIGNS, true);
        const marketingCampaign = await retrieveMarketingCampaignByCampaignKey(payload);
        console.log('retrieved marketing campaign:');
        console.log(marketingCampaign);
        context.commit(SET_ACTIVE_MARKETING_CAMPAIGN, marketingCampaign);
        context.commit(MANAGE_LOADING_MARKETING_CAMPAIGNS, false);
    },
    async requestResource(context, payload) {
        console.log('calling requestResource with contact:');
        console.log(payload);
        context.commit(CLEAR_ERRORS);
        context.commit(MANAGE_REQUESTING_RESOURCE, true);
        const results = await realEstateDataSvc.requestResource(payload);
        if (!results.successful) {
            console.log('request failed - setting errors to:');
            console.log(results.errors);
            context.commit(SET_ERRORS, results.errors);
        }
        context.commit(MANAGE_REQUESTING_RESOURCE, false);
    }
}